export const checkBrowser = () => {
    const userAgent = navigator.userAgent;
    return {
        // iPhone && UCBrowser
        isUCBrowser: userAgent.includes('iPhone') && userAgent.includes('UCBrowser'),
        // iPhone && QQBrowser
        isQQBrowser: userAgent.includes('iPhone') && userAgent.includes('QQBrowser'),
        // >= IE11
        isIEBrowser: !!globalThis.ActiveXObject || 'ActiveXObject' in globalThis
    }
}
